import UserAvatarPicker from './user_avatar_picker';

export default UserAvatarPicker;
